var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { Avatar, Card } from '@philips-internal/oswald-ui-components/lib/components';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { SelectionType, Size } from '@philips-internal/oswald-ui-constants';
import { string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import LoginLandingPageInfoCardAPI from './login-landing-page-info-card-api';
import LandingPageIcon from '../../constants/landing-page-icon';
import './login-landing-page-info-card.css';
import { generateUUID } from '@philips-internal/oswald-ui-utils/lib';
var AVATAR_PATH;
(function (AVATAR_PATH) {
    AVATAR_PATH["MY_CHART"] = "static/assets/icons/DLS_MeasurementProfile_48.svg";
    AVATAR_PATH["MY_PROFILE"] = "static/assets/icons/DLS_PersonProfile_48.svg";
    AVATAR_PATH["EXAMS_RESULTS"] = "static/assets/icons/DLS_ClipboardLines.svg";
    AVATAR_PATH["SCHEDULING"] = "static/assets/icons/DLS_Calendar.svg";
    AVATAR_PATH["PATIENT_PREPARATION"] = "static/assets/icons/DLS_ClipboardCheckmark_48.svg";
    AVATAR_PATH["TELECONSULTATION"] = "static/assets/icons/DLS_FileVideo.svg";
    AVATAR_PATH["POST_PROCEDURE"] = "static/assets/icons/DLS_FillInForm_48.svg";
    AVATAR_PATH["CARE_NAVIGATION"] = "static/assets/icons/DLS_PatientNurse_24.svg";
    AVATAR_PATH["LOGISTIC_SUPPORT"] = "static/assets/icons/DLS_PersonSupport_24.svg";
})(AVATAR_PATH || (AVATAR_PATH = {}));
let LoginLandingPageInfoCard = class LoginLandingPageInfoCard extends Component {
    static { this.propTypes = {
        description: string,
        icon: string,
        title: string,
    }; }
    getIcon(Icon) {
        switch (Icon) {
            case LandingPageIcon.MY_CHART: return AVATAR_PATH.MY_CHART;
            case LandingPageIcon.MY_PROFILE: return AVATAR_PATH.MY_PROFILE;
            case LandingPageIcon.EXAMS_RESULTS: return AVATAR_PATH.EXAMS_RESULTS;
            case LandingPageIcon.SCHEDULING: return AVATAR_PATH.SCHEDULING;
            case LandingPageIcon.PATIENT_PREPARATION: return AVATAR_PATH.PATIENT_PREPARATION;
            case LandingPageIcon.TELECONSULTATION: return AVATAR_PATH.TELECONSULTATION;
            case LandingPageIcon.POST_PROCEDURE: return AVATAR_PATH.POST_PROCEDURE;
            case LandingPageIcon.CARE_NAVIGATION: return AVATAR_PATH.CARE_NAVIGATION;
            case LandingPageIcon.LOGISTIC_SUPPORT: return AVATAR_PATH.LOGISTIC_SUPPORT;
            default: return '';
        }
    }
    renderInfoCard() {
        const { title, description, icon } = this.props;
        const iconPath = this.getIcon(icon);
        return (React.createElement("div", { className: 'login-landing-page-info-container' },
            React.createElement("div", { className: 'landing-page-info-card-avatar' },
                React.createElement("div", { className: 'landing-page-info-card-icon' },
                    React.createElement(Avatar, { image: iconPath, size: Size.XSMALL }))),
            React.createElement("div", { className: 'landing-page-info-content' },
                React.createElement("div", { className: 'landing-page-info-title' }, title),
                React.createElement("div", { className: 'landing-page-info-description' }, description))));
    }
    render() {
        return (React.createElement(Card, { className: 'login-landing-page-info-card', key: generateUUID(), selectionType: SelectionType.NONE, transparent: true, uuid: generateUUID(), width: 6 }, this.renderInfoCard()));
    }
};
LoginLandingPageInfoCard = __decorate([
    AwesomeComponent({ api: LoginLandingPageInfoCardAPI, type: ComponentType.DATA_DISPLAY })
], LoginLandingPageInfoCard);
export default LoginLandingPageInfoCard;
//# sourceMappingURL=login-landing-page-info-card.js.map